import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, CheckCircle, DollarSign } from 'lucide-react';

export const SecondaryKpis = ({ stats }) => {
  const trends = stats?.tendencias || [];
  
  const kpis = stats ? [
    {
      title: 'Ofertas Pendientes',
      value: stats.ofertas_pendientes,
      icon: TrendingUp,
      testId: 'kpi-ofertas-nuevas',
      showTrend: false,
      subtitle: 'Estado actual',
      trendIndex: 1
    },
    {
      title: 'Tasa de Adjudicación',
      value: `${stats.tasa_adjudicacion}%`,
      icon: CheckCircle,
      testId: 'kpi-tasa-adjudicacion',
      showTrend: true,
      subtitle: 'vs. mes anterior',
      trendIndex: 2
    },
    {
      title: 'Ofertas Totales',
      value: stats.total_ofertas,
      icon: DollarSign,
      testId: 'kpi-ofertas-totales',
      showTrend: true,
      subtitle: 'vs. mes anterior',
      trendIndex: 3
    },
  ] : [];

  if (!stats) return null;

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-5">
        {kpis.map((kpi) => {
          const Icon = kpi.icon;
          const trend = trends[kpi.trendIndex];
          return (
            <Card
              key={kpi.title}
              className="relative overflow-hidden bg-card border border-border hover:border-border/80 transition-all duration-300 shadow-lg"
              data-testid={kpi.testId}
            >
              <div className="absolute top-0 right-0 w-24 h-24 opacity-[0.03]">
                <Icon className="w-full h-full text-primary" />
              </div>
              <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="p-2.5 rounded-lg bg-primary/10 border border-primary/20">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <CardTitle className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
                      {kpi.title}
                    </CardTitle>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="flex items-end justify-between">
                  <div className="text-3xl font-bold text-foreground">{kpi.value}</div>
                  {kpi.showTrend && trend && (
                    <div className={`flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-md ${trend.isPositive
                        ? 'bg-green-500/10 text-green-600 dark:text-green-400 border border-green-500/20'
                        : 'bg-red-500/10 text-red-600 dark:text-red-400 border border-red-500/20'
                      }`}>
                      <span>{trend.isPositive ? '↑' : '↓'}</span>
                      <span>{trend.trend}</span>
                    </div>
                  )}
                </div>
                <p className="text-xs text-muted-foreground mt-2">{kpi.subtitle}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
